import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type IconProp, type SizeProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconProp,
  title?: string,
  text?: string,
  iconSize?: SizeProp
}

export default function EmptyState({ icon, title, text, iconSize }: Props) {
  return (
    <div className="p-4 text-center">
      {icon && (
        <div className="my-4">
          <FontAwesomeIcon className="icon-gradient" icon={icon} size={iconSize || 'lg'} />
        </div>
      )}
      {title && <h6 className="mb-4 fw-bold">{title}</h6>}
      {text && <p className="mb-4 text-neutral">{text}</p>}
    </div>
  );
}
